import { render, staticRenderFns } from "./EducationalStatusModal.vue?vue&type=template&id=f6ebb29a&scoped=true"
import script from "./EducationalStatusModal.vue?vue&type=script&lang=js"
export * from "./EducationalStatusModal.vue?vue&type=script&lang=js"
import style0 from "./EducationalStatusModal.vue?vue&type=style&index=0&id=f6ebb29a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ebb29a",
  null
  
)

export default component.exports